import script from "./register-interest-data-provider.vue?vue&type=script&lang=js"
export * from "./register-interest-data-provider.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__